/**
 * @param {HTMLElement} element 
 * @param {number} speed 
 * @param {'top'|'bottom'} type 
 * @returns {Promise<void>}
 */
export default function scrollToElem(element = document.body, speed = 4, type = 'top') {
   return new Promise((resolve) => { 
      
      const side = (type === 'top') ? 'top' : 'bottom';
      const offset = (type === 'bottom') ? window.innerHeight : 0;

      const d = element.getBoundingClientRect()[side] - offset;
      const firstPos = window.pageYOffset;
      const startTime = performance.now();
      const fullTime = Math.min(Math.abs(d / speed), 3000);

      if (speed === 0 || fullTime < 16) {
         window.scrollTo(0, firstPos + d);
         resolve();
         return;
      }

      requestAnimationFrame(function tik(time) {
         let progress = (time - startTime) / fullTime;

         progress = Math.min(progress, 1);
         progress = Math.max(progress, 0);

         const pos = firstPos + (d * progress);
         window.scrollTo(0, pos);
         
         if (progress < 1 && time - startTime < fullTime * 1.5) {
            requestAnimationFrame(tik);
         } else {
            requestAnimationFrame(() => resolve());
         }

      });

   });
}
